import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import axios from 'axios';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { API_URL } from '../../../Config';
import { VISAKA_SERVICES_API_URL } from '../../../Config';
import { CAMPAIGN_ID_ENQUIRY } from '../../../Config';
import CleanNumericInput from './CleanNumericInput';

const EnquireNowForm = ({ dynamicInputs, customInitialValues }) => {
    const [loading, setLoading] = useState(false);
    const [searchParams] = useSearchParams();
    const cId = searchParams.get('c_id') || null;
    const source = searchParams.get('src') || null;

    const campaignId = cId && cId.trim() !== "" ? cId : CAMPAIGN_ID_ENQUIRY;
    const campaignSource = source && source.trim() !== "" ? source : 'website';

    // START GEO SERVICES HOOKS
    const [stateList, setStateList] = useState([]);
    const [districtList, setDistrictList] = useState([]);
    const [allDistricts, setAllDistricts] = useState([]);
    const [zoneList, setZoneList] = useState([]);
    // END GEO SERVICES HOOKS

    const navigate = useNavigate();

    // START GEO SERVICES API FOR STATE & DISTRICT DROPDOWNS
    const fetchStateDistrictInfo = async () => {
        const response = await fetch(VISAKA_SERVICES_API_URL + "api/v2/geoservice/district/IN");
        const data = await response.json();

        setStateList(data.state);
        setAllDistricts(data.district);
        setZoneList(data.zones);
    };
    useEffect(() => {
        fetchStateDistrictInfo();
    }, []);

    const handleStateDistrict = (e) => {
        const selectedStateName = e.target.value;
        formik.setFieldValue('state', selectedStateName);

        // Find the selected state using state_name
        const selectedStateObj = stateList.find(
            (state) => state.state_name === selectedStateName
        );

        if (selectedStateObj) {
            // Get zonal_name using zonal_code
            const zoneObj = zoneList.find(
                (zone) => zone.zonal_code === selectedStateObj.zonal_code
            );

            if (zoneObj) {
                formik.setFieldValue('zonal_name', zoneObj.zonal_name);
            } else {
                formik.setFieldValue('zonal_name', '');
            }

            // Filter districts by state_code
            const filteredDistricts = allDistricts.filter(
                (dist) => dist.state_code === selectedStateObj.state_code
            );
            setDistrictList(filteredDistricts);
        } else {
            // Clear if not found
            setDistrictList([]);
            formik.setFieldValue('zone', '');
        }
    };
    // END GEO SERVICES API FOR STATE & DISTRICT DROPDOWNS

    const formik = useFormik({
        initialValues: { ...customInitialValues, zonal_name: '' },
        validate: (values) => {
            let errors = {};
            if (!values.name) { errors.name = 'Name is required'; }
            if (!values.email) { errors.email = 'Email is required'; } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) { errors.email = 'Invalid email address'; }
            if (!values.phone) { errors.phone = 'Mobile number is required'; } else if (!/^\d{10}$/.test(values.phone)) { errors.phone = 'Only 10 digit numbers are allowed'; }
            if (!values.state) { errors.state = 'State is required'; }
            if (!values.district) { errors.district = 'District is required'; }
            if (!values.city) { errors.city = 'City is required'; }
            if (!values.pincode) { errors.pincode = 'Pin code required'; } else if (!/^\d{6}$/.test(values.pincode)) { errors.pincode = 'Only 6 digit numbers are allowed'; }
            dynamicInputs.forEach(concept => {
                if (!values[concept.ch_stage_id]) { errors[concept.ch_stage_id] = concept.ch_stage_title + ' is required'; }
            });
            return errors;
        },

        onSubmit: async (values) => {
            setLoading(true);
            const formData = new FormData();
            formData.append("name", values.name)
            formData.append("email", values.email)
            formData.append("phone_number", values.phone)
            formData.append("state", values.state)
            formData.append("district", values.district)
            formData.append("city", values.city)
            formData.append("pincode", values.pincode)
            formData.append("category", "Item enquiry")
            formData.append("campaign_id", campaignId)
            formData.append("source", campaignSource);
            formData.append("zonal_name", values.zonal_name)

            var enquiry_requirements = {};
            dynamicInputs.forEach(concept => { enquiry_requirements[concept.ch_stage_id] = values[concept.ch_stage_id]; });
            formData.append("enquiry_requirements", JSON.stringify(enquiry_requirements));

            try {
                const response = await axios.post(`${API_URL}atum/enquiries/create`, formData);
                if (response.data.status === 200) {
                    navigate('/success');
                } else {
                    navigate('/error');
                }
                formik.resetForm();
            } catch (err) {
                console.log(err);
            } finally {
                setLoading(false);
            }
        }
    });

    var formDynamicUi = [];
    dynamicInputs.forEach(concept => {
        if (typeof concept.ch_sub !== "undefined" && concept.ch_sub.length > 0) {
            formDynamicUi.push(
                <div className="col-12 col-sm-12 col-md-6 col-lg-6 py-2 px-1 atc_select" key={`dynamic_${concept.ch_stage_id}`}>
                    <select className="form-select" name={concept.ch_stage_id} onChange={formik.handleChange} value={formik.values[concept.ch_stage_id] || ''}>
                        <option value="" defaultValue>{`Select ${concept.ch_stage_title}`}</option>
                        {concept.ch_sub.map((subOption) => (
                            <option value={subOption.ch_stage_title} key={subOption.ch_stage_id}>
                                {subOption.ch_stage_title}
                            </option>
                        ))}
                    </select>
                    {formik.errors[concept.ch_stage_id] ? <span className="text-danger fs-8">{formik.errors[concept.ch_stage_id]}</span> : null}
                </div>
            );
        } else {
            formDynamicUi.push(
                <div className="col-12 col-sm-12 col-md-6 col-lg-6 py-2 px-1" key={`dynamic_${concept.ch_stage_id}`}>
                    <input
                        className="form-control"
                        type="text"
                        name={concept.ch_stage_id}
                        placeholder={`Enter ${concept.ch_stage_title}`}
                        onChange={formik.handleChange}
                        value={formik.values[concept.ch_stage_id] || ''}
                    />
                    {formik.errors[concept.ch_stage_id] ? <span className="text-danger fs-8">{formik.errors[concept.ch_stage_id]}</span> : null}
                </div>
            );
        }
    });

    return (
        <div>
            <section className="bg-white22 py-1">
                <div className="container m-0 p-0">
                    <div className="row m-0 p-0">
                        <form onSubmit={formik.handleSubmit} className="m-0 p-0">
                            <input type='hidden' name='zonal_name' value={formik.values.zonal_name} />
                            <div className="row m-0 p-0">
                                <div className="col-12 col-sm-12 col-md-6 col-lg-6 py-2 px-1">
                                    <input className="form-control" type="text" name="name" placeholder="Enter Name*" onChange={formik.handleChange} value={formik.values.name} />
                                    {formik.errors.name ? <span className="text-danger fs-8">{formik.errors.name}</span> : null}
                                </div>
                                <div className="col-12 col-sm-12 col-md-6 col-lg-6 py-2 px-1">
                                    <input className="form-control" type="text" name="email" placeholder="Enter Email*" onChange={formik.handleChange} value={formik.values.email} />
                                    {formik.errors.email ? <span className="text-danger fs-8">{formik.errors.email}</span> : null}
                                </div>
                                <div className="col-12 col-sm-12 col-md-6 col-lg-6 py-2 px-1">
                                    {/* <input className="form-control" type="text" name="phone" placeholder="Enter Phone No.*" maxLength={10} onChange={formik.handleChange} value={formik.values.phone} /> */}
                                    <input className="form-control" type="text" name="phone" placeholder="Enter Phone No.*" maxLength={10} value={formik.values.phone}
                                        onChange={(e) => {
                                            const cleaned = CleanNumericInput(e.target.value);
                                            formik.setFieldValue('phone', cleaned);
                                        }}
                                        onPaste={(e) => {
                                            e.preventDefault();
                                            const pasted = e.clipboardData.getData('Text');
                                            const cleaned = CleanNumericInput(pasted);
                                            formik.setFieldValue('phone', cleaned);
                                        }}
                                        onBlur={(e) => {
                                            const cleaned = CleanNumericInput(e.target.value);
                                            formik.setFieldValue('phone', cleaned);
                                        }}
                                    />
                                    {formik.errors.phone ? <span className="text-danger fs-8">{formik.errors.phone}</span> : null}
                                </div>
                                <div className="col-12 col-sm-12 col-md-6 col-lg-6 py-2 px-1 atc_select">
                                    <select className="form-select" name="state" onChange={handleStateDistrict} value={formik.values.state}>
                                        <option value="">Select State*</option>
                                        {stateList.map((state) => (
                                            <option value={state.state_name} key={state.id}>
                                                {state.state_name}
                                            </option>
                                        ))}
                                    </select>
                                    {formik.errors.state && <span className='text-danger mt-1 d-block'>{formik.errors.state}</span>}
                                </div>
                                <div className="col-12 col-sm-12 col-md-6 col-lg-6 py-2 px-1 atc_select">
                                    <select className="form-select" name="district" onChange={formik.handleChange} value={formik.values.district}>
                                        <option value="">Select District*</option>
                                        {districtList.map((dist) => (
                                            <option value={dist.district_name} key={`${dist.id}-${dist.district_name}`}>
                                                {dist.district_name}
                                            </option>
                                        ))}
                                    </select>
                                    {formik.errors.district && <span className='text-danger mt-1 d-block'>{formik.errors.district}</span>}
                                </div>
                                <div className="col-12 col-sm-12 col-md-6 col-lg-6 py-2 px-1">
                                    <input className="form-control" type="text" name="city" placeholder="City*" onChange={formik.handleChange} value={formik.values.city} />
                                    {formik.errors.city ? <span className="text-danger fs-8">{formik.errors.city}</span> : null}
                                </div>
                                <div className="col-12 col-sm-12 col-md-6 col-lg-6 py-2 px-1">
                                    <input className="form-control" type="text" name="pincode" placeholder="Enter Pincode*" maxLength={6} onChange={formik.handleChange} value={formik.values.pincode} />
                                    {formik.errors.pincode ? <span className="text-danger fs-8">{formik.errors.pincode}</span> : null}
                                </div>
                                {formDynamicUi.map(a => { return a })}
                                <div className="col-12 col-sm-12 col-md-12 col-lg-12 py-2 px-1 d-flex justify-content-center">
                                    <input type="submit" value={loading ? "Submitting..." : "Submit"} className="btn btn-danger fw-semibold global-primary-bg px-3" disabled={loading} />
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default EnquireNowForm